export enum BuildState {
  ALL = 'all',
  QUEUED = 'queued',
  RUNNING = 'running',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  FAILED_TO_START = 'failedToStart',
  CANCELED = 'canceled',
  PINNED = 'pinned',
  STARRED = 'starred',
}

export const StateOptions = {
  [BuildState.ALL]: {
    title: 'All',
    icon: null,
  },
  [BuildState.QUEUED]: {
    title: 'Queued',
    icon: 'queued',
  },
  [BuildState.RUNNING]: {
    title: 'Running',
    icon: 'running_static',
  },
  [BuildState.SUCCESSFUL]: {
    title: 'Successful',
    icon: 'finished_green',
  },
  [BuildState.FAILED]: {
    title: 'Failed',
    icon: 'finished_red',
  },
  [BuildState.FAILED_TO_START]: {
    title: 'Failed to start',
    icon: 'failedToStart',
  },
  [BuildState.CANCELED]: {
    title: 'Canceled',
    icon: 'canceled',
  },
  [BuildState.PINNED]: {
    title: 'Pinned',
    icon: 'pin',
  },
  [BuildState.STARRED]: {
    title: 'My Favorites',
    icon: 'star',
  },
} as const
